import ABCyaLib from '@abcya/abcya_lib';

export default function setupGameConfig(variantId, locale) {
  const { esUS } = ABCyaLib.Environment.LOCALES;

  const config = {
    // add your game config options here, these can be the default values
    instructionFontSize: 36,
    quizEnterButtonFontSize: 60,
    quizClearButtonFontSize: 42,
    mathResultsLinePosition: 200
  };

  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
  };

  switch (locale) {
    case esUS:
      config.instructionFontSize = 34
      config.quizEnterButtonFontSize = 50,
      config.quizClearButtonFontSize = 38,
      config.mathResultsLinePosition = 165
      break;
  }

  return config;
}